export default __webpack_public_path__ + "static/media/Paolo Piacentini.74e5f746.jpg";